<template>
  <div class="app-footer">
    <!-- [matrah] legacy:
    <v-footer height="60" class="bg-grey-lighten-1" :app="true">
      <v-col class="text-center mt-4" cols="12">
        {{ new Date().getFullYear() }} — <strong>{{ appName }}</strong>
      </v-col>
    </v-footer>
    -->
    <v-footer height="36" class="matrah-footer" :app="true">
      <div class="d-flex align-center justify-center w-100 footer-content">
        <img :src="logo" alt="Zakat Matrah" class="footer-logo" />
        <span>{{ new Date().getFullYear() }} — <strong>{{ appName }}</strong></span>
      </div>
    </v-footer>
  </div>
</template>

<script>
import logo from '../../assets/matrah-logo-transparent.png'

export default {

  data: () => ({
    appName: process.env.VUE_APP_NAME,
    logo,
  })
}
</script>

<style scoped>
.matrah-footer {
  background: #f1f4f1;
  border-top: 1px solid #dfe6e0;
  color: #4b5a4f;
  font-size: 12px;
}

.footer-content {
  gap: 8px;
}

.footer-logo {
  height: 22px;
  width: auto;
}
</style>
